module.exports = __webpack_public_path__ + "img/tax_b3@2x.512ad5c4.png";